import Axios from 'configs/Axios';
import {
  ActiveSiteResponseData,
  GetSiteByNameResponse,
  SiteData,
  SiteFormValues,
  SiteResponseData,
  SiteSettings,
  SitesFilters,
  UpdateSiteRequest,
} from 'types/sites';

export const getAllSites = (filters?: SitesFilters) =>
  Axios.get<SiteResponseData>('/site', {
    params: filters,
  });

export const getSiteByName = (name: string) =>
  Axios.get<GetSiteByNameResponse>(`/site/byName/${name}`);

export const getSiteById = (id: string) => Axios.get<SiteData>(`/site/${id}`);

export const addNewSite = (data: SiteFormValues) =>
  Axios.post<SiteData>('/site', data);

export const updateSite = (data: UpdateSiteRequest) => Axios.put('/site', data);

export const deleteSite = (id: string) => Axios.delete(`/site/${id}`);

export const getActiveTrustSite = () =>
  Axios.get<ActiveSiteResponseData>(`/activeTrust/site`);

export const getMergedSiteSettings = async (siteIds: string[]) => {
  return Axios.get<SiteSettings>('/site/settings/merged', {
    params: { siteIds: siteIds.join(',') },
  });
};
